import { connectFela } from '../../dependencies';
import LoginForm from './LoginForm';
import * as styles from './LoginForm.styles';

export default connectFela(styles)(LoginForm);
